import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

export default class SuccessMessage extends Component {
    static propTypes = {
        message: PropTypes.string.isRequired,
        removeAfter: PropTypes.number,
    };

    state = {
        visible: true,
    };

    componentDidMount() {
        if (this.props.removeAfter) {
            this.timeoutId = setTimeout(this.handleRemove.bind(this), this.props.removeAfter);
        }
    }

    componeWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    handleRemove() {
        this.setState({visible: false});
    }

    render() {
        if (!this.state.visible) return null;
        return <div className={styles.root}>{this.props.message}</div>;
    }
}



// WEBPACK FOOTER //
// ./components/success-message/index.js